import { render, staticRenderFns } from "./FormNpwp.vue?vue&type=template&id=50d33a02"
import script from "./FormNpwp.vue?vue&type=script&lang=js"
export * from "./FormNpwp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports